import request from '@/services/request'

export function fetchAll(data) {
  return request({
    url: process.env.BASE_URL_INVENTORY + '/master-recipe-detail/list',
    method: 'get',
    params: data
  })
}

export function changeStatusItem(data) {
  return request({
    url: process.env.BASE_URL_INVENTORY + '/master-recipe-detail/update-status',
    method: 'put',
    data: data
  })
}

export function changeStatusDefaultItem(data) {
  return request({
    url: process.env.BASE_URL_INVENTORY + '/master-recipe-detail/update-status-default',
    method: 'put',
    data: data
  })
}

export function get(data) {
  return request({
    url: process.env.BASE_URL_INVENTORY + '/master-recipe-detail/detail',
    method: 'get',
    params: data
  })
}

export function create(data) {
  return request({
    url: procss.env.BASE_URL_INVENTORY + '/master-recipe-detail/create',
    method: 'post',
    data: data
  })
}

export function update(data) {
  return request({
    url: process.env.BASE_URL_INVENTORY + '/master-recipe-detail/update',
    method: 'put',
    data: data
  })
}

export function getMasterRecipeDetailByRecipe (data) {
  return request({
    url: process.env.BASE_URL_INVENTORY + '/master-recipe-detail/get-by-recipe',
    method: 'get',
    params: data
  })
}






// WEBPACK FOOTER //
// ./src/api/master_recipe_detail.js